import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SkillsMatrixVersions from './index';
import { skillsApi } from '../../../services/api';
import LoadingSpinner from '../../common/LoadingSpinner';
import { useAlert } from '../../../contexts/AlertContext';

const SelectVersionsWrapper = () => {
  const { sessionId, matrixId } = useParams();
  const { showAlert } = useAlert();
  const [initialSelectedVersions, setInitialSelectedVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchExistingSelections = async () => {
      try {
        setLoading(true);
        const existingVersions = await skillsApi.getSessionMatrixVersions(sessionId, matrixId);
        // Extract version IDs from the response
        setInitialSelectedVersions(existingVersions);
      } catch (error) {
        // If there are no existing selections (404), that's fine - start with empty array
        if (error.status !== 404) {
          showAlert('Failed to load existing selections', 'error');
          console.error('Error fetching existing selections');
        }
        setInitialSelectedVersions([]);
      } finally {
        setLoading(false);
      }
    };

    if (sessionId && matrixId) {
      fetchExistingSelections();
    }
  }, [sessionId, matrixId, showAlert]);
  
  const handleSelectionConfirm = async (selectedVersions) => {
    // Associate selected versions with the session
    await skillsApi.addVersionsToSession(sessionId, matrixId, selectedVersions);
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <SkillsMatrixVersions 
      isSelectionMode={true}
      sessionId={sessionId}
      onSelectionConfirm={handleSelectionConfirm}
      selectionBackPath={`/skills-matrix/sessions/${sessionId}`}
      selectionBackText="Back to Session"
      selectionTitle="Select Matrix Versions"
      initialSelectedVersions={initialSelectedVersions}
    />
  );
};

export default SelectVersionsWrapper; 